import React, { useState, useEffect } from 'react';
import MuiAlert from '@mui/material/Alert';
import { Snackbar } from '@mui/material';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SnackbarAlertWidget = ({
  message,
  alert,
  time = 4000,
  state = () => {},
  black,
  success,
  warning,
  error,
  topRight,
  bottomCenter,
}) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(null);
  const [anchorOrigin, setAnchorOrigin] = useState({
    vertical: 'top',
    horizontal: 'center',
  });

  useEffect(() => {
    if (!message && !alert) {
      setOpen(false);
      return;
    }

    setText(alert?.title ?? message);

    if (topRight) setAnchorOrigin({ vertical: 'top', horizontal: 'right' });
    if (bottomCenter)
      setAnchorOrigin({ vertical: 'bottom', horizontal: 'center' });

    setOpen(alert || message);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alert, message]);

  function handleClose() {
    setOpen(false);
    state();
  }

  return black ? (
    <Snackbar
      open={open}
      autoHideDuration={time}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      message={text}
    />
  ) : (
    <Snackbar
      open={open}
      autoHideDuration={time}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert
        onClose={handleClose}
        severity={
          alert?.severity ?? success
            ? 'success'
            : error
            ? 'error'
            : warning
            ? 'warning'
            : 'info'
        }
        sx={{ width: '100%' }}
      >
        {text}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarAlertWidget;
